var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { AuthWidget } from "./AuthWidget.js";
import "./index.scss";
import styles from "./styles.scss";
let host = null;
let customStyle = null;
let root = null;
let state = null;
const applyCustomStyle = (css) => {
    var _a;
    if (!customStyle)
        return;
    customStyle.textContent = css || "";
    (_a = customStyle.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(customStyle);
};
export const ensureWidgetLoaded = () => __awaiter(void 0, void 0, void 0, function* () {
    if (root)
        return;
    if (typeof document === "undefined")
        throw new Error("SMM Auth Widget requires a browser");
    host = document.getElementById("smm-auth-widget-host");
    if (!host) {
        host = document.createElement("div");
        host.id = "smm-auth-widget-host";
        document.body.appendChild(host);
    }
    const shadow = host.shadowRoot || host.attachShadow({ mode: "open" });
    if (!shadow.querySelector("[data-smm-auth-style]")) {
        const style = document.createElement("style");
        style.dataset.smmAuthStyle = "true";
        style.textContent = styles;
        shadow.appendChild(style);
    }
    customStyle = shadow.querySelector("[data-smm-auth-custom-style]");
    if (!customStyle) {
        customStyle = document.createElement("style");
        customStyle.dataset.smmAuthCustomStyle = "true";
        shadow.appendChild(customStyle);
    }
    let container = shadow.getElementById("smm-auth-widget-root");
    if (!container) {
        container = document.createElement("div");
        container.id = "smm-auth-widget-root";
        shadow.appendChild(container);
    }
    root = createRoot(container);
});
export const openWidget = (config, options, onClose) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    yield ensureWidgetLoaded();
    const widgetOptions = Object.assign(Object.assign({}, options), { mask: (_a = options.mask) !== null && _a !== void 0 ? _a : true, maskClosable: (_b = options.maskClosable) !== null && _b !== void 0 ? _b : true });
    state = {
        open: true,
        action: widgetOptions.action || "login",
        options: widgetOptions,
        config,
    };
    applyCustomStyle(widgetOptions.modalCss);
    render(onClose);
    applyCustomStyle(widgetOptions.modalCss);
});
export const closeWidget = (reason, onClose) => {
    if (!state)
        return;
    state = Object.assign(Object.assign({}, state), { open: false, action: "login" });
    render(onClose);
    onClose(reason);
};
const render = (onClose) => {
    if (!root || !state)
        return;
    root.render(_jsx(AuthWidget, { state: state, onClose: (reason) => closeWidget(reason, onClose) }));
};
//# sourceMappingURL=mount.js.map